import { AppBar, Box, Toolbar, Stack, SxProps, Container } from "@mui/material";
import { Common, Custom, Menu } from "components";
import { useNavigationAction } from "hooks";

// icons
import { DarkModeRounded, MenuRounded } from "@mui/icons-material";

type Props = {
  sx?: SxProps;
};

export const Navbar = (props: Props) => {
  const {
    t,
    theme,
    isAuthenticated,
    user,
    opened,
    openSidebar,
    closeSidebar,
    handleNew,
    handleLogin,
    handleProfile,
    handleLogout,
    handleTheme,
  } = useNavigationAction();

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          boxShadow: 0,
          height: theme.component.layout.navbar.height,
          backgroundColor: theme.color.background.accent,
          ...props.sx,
        }}
      >
        <Container>
          <Toolbar sx={{ height: theme.component.layout.navbar.height }}>
            <Box display={{ xs: "initial", md: "none" }}>
              <Custom.IconButton
                size="large"
                onClick={openSidebar}
                foreground={theme.color.font.color}
              >
                <MenuRounded />
              </Custom.IconButton>
            </Box>
            <Common.Logo key="logo_navbar" />
            <Stack
              direction="row"
              alignItems="center"
              spacing={theme.spacing.sm}
              ml={{ xs: "unset", md: "auto" }}
            >
              <Stack
                direction="row"
                spacing={theme.spacing.sm}
                display={{ xs: "none", md: "initial" }}
              >
                <Custom.Button
                  size="small"
                  onClick={handleNew}
                  sx={{
                    color: theme.color.font.color,
                    fontWeight: theme.font.semiBold,
                  }}
                >
                  {t.component.common.navbar.start_potluck}
                </Custom.Button>
              </Stack>
              <Stack direction="row" spacing={theme.spacing.sm}>
                {isAuthenticated && <Menu.Navigation />}
                {!isAuthenticated && (
                  <Custom.Button
                    size="small"
                    onClick={handleLogin}
                    sx={{
                      color: theme.color.font.color,
                      fontWeight: theme.font.semiBold,
                    }}
                  >
                    {t.component.common.navbar.sign_in}
                  </Custom.Button>
                )}
              </Stack>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>
      <Common.Sidebar opened={opened} onClose={closeSidebar} />
    </>
  );
};
